import { forwardRef, type ImgHTMLAttributes } from 'react';
import type { TypeImageDetailed } from 'types/autogen/contentful';
import type { Breakpoint } from 'variables';
import Image from './Image';
import { createSrcSet } from './shared/helpers';

type PictureProps = {
    desktopImage: TypeImageDetailed | undefined;
    image: TypeImageDetailed | undefined;
} & ImgHTMLAttributes<HTMLImageElement>;

const Picture = forwardRef<HTMLImageElement, PictureProps>((props, ref) => {
    const { image, desktopImage, sizes, ...restProps } = props;
    if (!image) return;

    const defaultImageAsset = image.fields.localizedImage || image.fields.image;
    const desktopImageAsset = desktopImage?.fields?.localizedImage || desktopImage?.fields.image;
    const { file } = defaultImageAsset?.fields || {};

    const breakPoint: Breakpoint = '1025px';

    return (
        <picture style={{ width: '100%' }}>
            {file && <source media={`(max-width: ${breakPoint})`} srcSet={createSrcSet(file)} sizes={sizes} />}
            {desktopImageAsset?.fields.file && (
                <source
                    media={`(min-width: ${breakPoint})`}
                    srcSet={createSrcSet(desktopImageAsset.fields.file)}
                    sizes={sizes}
                />
            )}
            <Image style={{ width: '100%' }} ref={ref} {...image} {...restProps} />
        </picture>
    );
});

export default Picture;
